export const appStateStore = {
  state: {
    firstTimeRun: true,
    debugImageUploaderActive: false,
    isModuleOpen: false,
    moduleIndex: 0
  },
  getters: {
    firstTimeRun: (state) => {
      return state.firstTimeRun;
    },
    debugImageUploaderActive: (state) => {
      return state.debugImageUploaderActive;
    },
    isModuleOpen: (state) => {
      return state.isModuleOpen;
    },
    moduleIndex: (state) => {
      return state.moduleIndex;
    },
  },
  mutations: {
    setFirstTimeRun(state, target) {
      state.firstTimeRun = target;
    },
    debugImageUploaderActive(state, target) {
      state.debugImageUploaderActive = target;
    },
    isModuleOpen(state, target) {
      state.isModuleOpen = target;
    },
    moduleIndex(state, target) {
      state.moduleIndex = target;
    },
  }
};
